/**
 * Spa Solutions Discount System v2.0.0
 * =====================================
 * Metaobject-based discount system — full rewrite after SkyPergola pattern.
 *
 * Key principles:
 *   - Prices are pre-calculated in Liquid (variant-prices JSON)
 *   - Only 1 localStorage key for preference: assemblyPreference ("1" or "2")
 *   - Callback-based sync chain (no Promise queue, no window.fetch wrapping)
 *   - Each sync function fetches /cart.js internally (no stale data)
 *   - Cart Assembly Toggle in mini-cart AND cart page
 *   - Final sync before checkout redirect
 */
(function () {
  "use strict";

  // ============================================================
  // MODULE: Config & Constants
  // ============================================================

  var BAUGESUCH_VARIANT_ID = "47461591318756";
  var KRAN_VARIANT_ID = "47461604294884";

  // ============================================================
  // MODULE: Currency Formatting
  // ============================================================

  function formatMoney(cents) {
    var amount = (parseInt(cents || 0, 10) / 100).toFixed(2);
    var currency = window.shop_currency || "CHF";
    var parts = amount.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, "'");
    return currency + " " + parts.join(".");
  }

  function parseMoneyTextToCents(txt) {
    if (!txt) return 0;
    var cleaned = txt.replace(/[A-Za-z\u00A0]/g, "").trim();
    var m = cleaned.match(/[\d'.,\s]+/);
    if (!m) return 0;
    var s = m[0].trim();
    var lastComma = s.lastIndexOf(",");
    var lastDot = s.lastIndexOf(".");
    if (lastComma > lastDot) {
      s = s.replace(/\./g, "").replace(",", ".");
    } else {
      s = s.replace(/[',\s]/g, "");
    }
    var value = parseFloat(s);
    return isNaN(value) ? 0 : Math.round(value * 100);
  }

  window.formatMoney = formatMoney;
  window.formatMoneyDrawer = formatMoney;
  window.parseMoneyTextToCents = parseMoneyTextToCents;

  // ============================================================
  // MODULE: Assembly Preference (single localStorage key)
  // ============================================================

  function getAssemblyPreference() {
    try {
      return parseInt(localStorage.getItem("assemblyPreference") || "1", 10);
    } catch (e) {
      return 1;
    }
  }

  function setAssemblyPreference(buttonNumber) {
    try {
      localStorage.setItem("assemblyPreference", String(buttonNumber));
    } catch (e) {}
  }

  window.getAssemblyPreference = getAssemblyPreference;

  // ============================================================
  // MODULE: Variant Prices (pre-calculated in Liquid)
  // ============================================================

  var variantPricesCache = null;

  function getVariantPrices() {
    if (variantPricesCache) return variantPricesCache;
    var script = document.querySelector('[id^="variant-prices-"]');
    if (!script) return null;
    try {
      variantPricesCache = JSON.parse(script.textContent.trim());
      return variantPricesCache;
    } catch (e) {
      return null;
    }
  }

  // ============================================================
  // MODULE: Price Container Helpers
  // ============================================================

  function getPriceContainer() {
    var inner = document.querySelector(".price_list_wrapper[data-variant-price]");
    if (inner) return inner;
    return document.querySelector(".product-form__info-list, [data-product-price]");
  }

  function getCurrentVariantId() {
    var input = document.querySelector('input[name="id"]:checked')
      || document.querySelector('select[name="id"]')
      || document.querySelector('input[name="id"]');
    return input ? input.value : null;
  }

  window.getPriceContainer = getPriceContainer;

  // ============================================================
  // MODULE: Product Page - Price Update
  // ============================================================

  function updateProductPagePrice(variantIdOverride) {
    var priceContainer = getPriceContainer();
    if (!priceContainer) return;

    var variantId = variantIdOverride || getCurrentVariantId();
    var prices = getVariantPrices();
    if (!variantId || !prices) return;

    var vData = prices[variantId];
    if (!vData) return;

    var pref = getAssemblyPreference();
    var originalPrice = vData.price;
    var compareAtPrice = vData.compare_at_price || 0;
    var discountAmount = 0;
    var finalPrice = originalPrice;
    var discountCode = "";

    if (pref === 1 && vData.eigenmontage_pct > 0) {
      discountAmount = vData.eigenmontage_discount;
      finalPrice = originalPrice - discountAmount;
      discountCode = vData.eigenmontage_code || "";
    } else if (pref === 2 && vData.montage_pct > 0) {
      discountAmount = vData.montage_discount;
      finalPrice = originalPrice - discountAmount;
      discountCode = vData.montage_code || "";
    }

    // Update main price element
    var priceEl = priceContainer.querySelector(".price-list .price")
      || priceContainer.querySelector(".price:not(.price--compare)");
    if (priceEl) {
      priceEl.textContent = formatMoney(finalPrice);
    }

    // Compare price (strikethrough)
    var comparePriceEl = priceContainer.querySelector(".price--compare");
    if (comparePriceEl) {
      var priceToCompare = compareAtPrice > 0 ? compareAtPrice : originalPrice;
      var shouldShow = discountAmount > 0 || (compareAtPrice > 0 && compareAtPrice > finalPrice);
      if (shouldShow) {
        var compareAmountEl = comparePriceEl.querySelector(".amount");
        if (compareAmountEl) {
          compareAmountEl.textContent = formatMoney(priceToCompare);
        } else {
          // This theme renders no .amount wrapper — the compare span holds a
          // .visually-hidden label plus a raw price text node (in comma format
          // from theme.js). Rewrite the price in Swiss apostrophe format while
          // preserving the a11y label so it matches the highlight price.
          var compareLabelEl = comparePriceEl.querySelector(".visually-hidden");
          comparePriceEl.innerHTML =
            (compareLabelEl ? compareLabelEl.outerHTML : "") + formatMoney(priceToCompare);
        }
        comparePriceEl.style.display = "";
      } else {
        comparePriceEl.style.display = "none";
      }
    }

    // Savings display
    var parentContainer = priceContainer.parentElement;
    var savingsEl = parentContainer
      ? parentContainer.querySelector(".product-form-saving-price")
      : document.querySelector(".product-form-saving-price");
    if (savingsEl) {
      var totalSavings = discountAmount;
      if (compareAtPrice > 0 && compareAtPrice > finalPrice) {
        totalSavings = compareAtPrice - finalPrice;
      }
      if (totalSavings > 0) {
        savingsEl.innerHTML = (window.spaT ? window.spaT('save_label', 'Spare:') : 'Spare:') + ' <span class="product-savings-amount">' + formatMoney(totalSavings) + '</span>';
        savingsEl.style.display = "block";
      } else {
        savingsEl.style.display = "none";
      }
    }

    // Applied discount pill
    updateAppliedDiscountPill(discountCode, discountAmount);

    // Update data attributes for other consumers
    priceContainer.setAttribute("data-variant-price", originalPrice);
    priceContainer.setAttribute("data-compare-at-price", compareAtPrice || 0);
  }

  window.updateProductPagePrice = updateProductPagePrice;

  function updateAppliedDiscountPill(code, amount) {
    var el = document.getElementById("applied-discount");
    var textEl = document.getElementById("applied-discount-text");
    if (!el || !textEl) return;

    if (!code || amount <= 0) {
      el.style.display = "none";
      return;
    }

    textEl.textContent = code;
    el.style.display = "";
  }

  // ============================================================
  // MODULE: Product Page - Button Toggle
  // ============================================================

  window.handleDiscountButtonClick = function (_discountTitle, buttonElement) {
    if (!buttonElement) return false;

    var allButtons = document.querySelectorAll(".discount-button");
    allButtons.forEach(function (btn) { btn.classList.remove("active"); });
    buttonElement.classList.add("active");

    var buttonNumber = parseInt(buttonElement.getAttribute("data-button-number") || "1", 10);
    setAssemblyPreference(buttonNumber);

    // Only update PDP visuals — NO cart sync, NO assembly toggle update
    // Assembly toggle updates when user adds to cart (via runPostAddSync)
    updateProductPagePrice();

    // Update montage property input
    updateMontageProperty();

    // No cart sync on PDP button click — sync happens on add-to-cart
    // or when user toggles assembly in mini-cart/cart-page

    // Dispatch for pricing-info-row etc.
    document.dispatchEvent(new CustomEvent("spa:discount-changed", {
      detail: { buttonNumber: buttonNumber }
    }));

    return true;
  };

  // ============================================================
  // MODULE: Montage Property Input
  // ============================================================

  function updateMontageProperty(variantIdOverride) {
    var montageInput = document.querySelector("#montage-property-input");
    if (!montageInput) return;

    var pref = getAssemblyPreference();
    var btn2Active = pref === 2;

    if (!btn2Active) {
      montageInput.value = "";
      montageInput.disabled = true;
      return;
    }

    montageInput.disabled = false;

    var variantId = variantIdOverride || getCurrentVariantId();
    var linkedEl = document.querySelector('[id^="linked-variants-data-"]');
    if (!linkedEl || !variantId) {
      montageInput.value = "Montage durch Spa Solutions";
      return;
    }

    try {
      var data = JSON.parse(linkedEl.textContent.trim());
      var linked = data[String(variantId)];
      if (linked && linked.length > 0 && linked[0].price) {
        var priceInCHF = (linked[0].price / 100).toLocaleString("de-CH", {
          minimumFractionDigits: 2, maximumFractionDigits: 2
        });
        montageInput.value = "Montage durch Spa Solutions (CHF " + priceInCHF + ")";
      } else {
        montageInput.value = "Montage durch Spa Solutions";
      }
    } catch (e) {
      montageInput.value = "Montage durch Spa Solutions";
    }
  }

  // ============================================================
  // MODULE: Cart Syncing State (loading overlay)
  // ============================================================

  function setCartSyncingState() {
    var miniCart = document.getElementById("mini-cart");
    if (miniCart) {
      miniCart.setAttribute("data-syncing", "true");
      if (!miniCart.querySelector(".spa-cart-spinner")) {
        var spinner = document.createElement("div");
        spinner.className = "spa-cart-spinner";
        spinner.innerHTML = '<div class="spa-cart-spinner__dot"></div><div class="spa-cart-spinner__dot"></div><div class="spa-cart-spinner__dot"></div>';
        var content = miniCart.querySelector(".mini-cart__content, .mini-cart__inner");
        if (content) content.appendChild(spinner);
      }
    }
    var cartSection = document.querySelector("[data-section-type='cart']");
    if (cartSection) {
      cartSection.setAttribute("data-syncing", "true");
      if (!cartSection.querySelector(".spa-cart-spinner")) {
        var spinner2 = document.createElement("div");
        spinner2.className = "spa-cart-spinner";
        spinner2.innerHTML = '<div class="spa-cart-spinner__dot"></div><div class="spa-cart-spinner__dot"></div><div class="spa-cart-spinner__dot"></div>';
        var wrapper = cartSection.querySelector(".cart-wrapper__inner, .cart-wrapper");
        if (wrapper) wrapper.appendChild(spinner2);
      }
    }
  }

  function clearCartSyncingState() {
    var miniCart = document.getElementById("mini-cart");
    if (miniCart) {
      miniCart.removeAttribute("data-syncing");
      var spinner = miniCart.querySelector(".spa-cart-spinner");
      if (spinner) spinner.remove();
    }
    var cartSection = document.querySelector("[data-section-type='cart']");
    if (cartSection) {
      cartSection.removeAttribute("data-syncing");
      var spinner2 = cartSection.querySelector(".spa-cart-spinner");
      if (spinner2) spinner2.remove();
    }
  }

  // ============================================================
  // MODULE: Cart Assembly Toggle
  // ============================================================

  function initCartAssemblyToggles() {
    var pref = getAssemblyPreference();
    var toggles = document.querySelectorAll("[data-cart-assembly-toggle]");
    toggles.forEach(function (toggle) {
      var btn1 = toggle.querySelector('[data-assembly-btn="1"]');
      var btn2 = toggle.querySelector('[data-assembly-btn="2"]');
      if (!btn1 || !btn2) return;
      btn1.classList.toggle("active", pref === 1);
      btn2.classList.toggle("active", pref === 2);
      toggle.removeAttribute("data-syncing");
    });
  }

  window.initCartAssemblyToggles = initCartAssemblyToggles;

  function handleAssemblyToggleClick(btn) {
    if (!btn) return;

    var toggle = btn.closest("[data-cart-assembly-toggle]");
    if (!toggle) return;

    var buttonNumber = parseInt(btn.getAttribute("data-assembly-btn") || "1", 10);
    var currentPref = getAssemblyPreference();

    if (buttonNumber === currentPref) return;
    if (toggle.hasAttribute("data-syncing")) return;

    // Set syncing state on ALL toggles + cart UI
    document.querySelectorAll("[data-cart-assembly-toggle]").forEach(function (t) {
      t.setAttribute("data-syncing", "true");
    });
    setCartSyncingState();

    setAssemblyPreference(buttonNumber);

    // Switch active state on all toggles immediately
    document.querySelectorAll("[data-cart-assembly-toggle]").forEach(function (t) {
      var b1 = t.querySelector('[data-assembly-btn="1"]');
      var b2 = t.querySelector('[data-assembly-btn="2"]');
      if (b1) b1.classList.toggle("active", buttonNumber === 1);
      if (b2) b2.classList.toggle("active", buttonNumber === 2);
    });

    // Sync PDP buttons if visible
    document.querySelectorAll(".discount-button").forEach(function (dbtn) {
      var btnNum = parseInt(dbtn.getAttribute("data-button-number") || "0", 10);
      dbtn.classList.toggle("active", btnNum === buttonNumber);
    });

    updateProductPagePrice();

    function clearSyncingState() {
      document.querySelectorAll("[data-cart-assembly-toggle]").forEach(function (t) {
        t.removeAttribute("data-syncing");
      });
      clearCartSyncingState();
    }

    var syncSafetyTimer = setTimeout(clearSyncingState, 12000);

    // Toggle only changes preference — no duplicates to consolidate.
    // All 5 syncs affect disjoint line items (main properties vs. montage/shipping/
    // baugesuch/kran companions), so they run in parallel.
    Promise.all([
      promisify(syncMontageProperty),
      promisify(syncMontageInCart),
      promisify(syncShippingInCart),
      promisify(syncBaugesuchInCart),
      promisify(syncKranInCart)
    ]).then(function () {
      clearTimeout(syncSafetyTimer);
      if (/\/cart(\?|$|\/?$)/.test(window.location.pathname)) {
        refreshCartPageSection().then(clearSyncingState);
      } else {
        clearSyncingState();
        refreshMiniCartSection();
      }
    });
  }

  window.handleAssemblyToggleClick = handleAssemblyToggleClick;

  // Fallback delegation for cases where inline onclick isn't present
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-assembly-btn]");
    if (btn) handleAssemblyToggleClick(btn);
  });

  // ============================================================
  // MODULE: Variant Change Handler
  // ============================================================

  function handleVariantChange(event) {
    variantPricesCache = null; // Clear cache to re-read
    // theme.js dispatches "variant:changed" BEFORE it commits the new id to
    // select[name="id"], so getCurrentVariantId() would still read the previous
    // variant at this point (off-by-one price). Prefer the authoritative variant
    // carried in the event payload; fall back to the DOM for other dispatchers.
    var variantId = (event && event.detail && event.detail.variant && event.detail.variant.id)
      ? String(event.detail.variant.id)
      : null;
    updateProductPagePrice(variantId);
    updateMontageProperty(variantId);
  }

  // ============================================================
  // MODULE: Localized Property Keys
  // ============================================================

  function getMontagePropertyKey() {
    var labels = { en: "Für", de: "Für", fr: "Pour", it: "Per" };
    var lang = (document.documentElement.lang || "de").split("-")[0].toLowerCase();
    return labels[lang] || "Für";
  }

  function buildForValue(cartItem) {
    var title = cartItem.product_title || cartItem.title || "";
    var variant = cartItem.variant_title || "";
    if (variant && variant !== "Default Title") {
      title += " " + variant;
    }
    return title;
  }

  function buildForValueFromDOM() {
    var script = document.querySelector('[id^="variant-for-values-"]');
    var variantId = getCurrentVariantId();
    if (script && variantId) {
      try {
        var map = JSON.parse(script.textContent.trim());
        if (map[variantId]) return map[variantId];
      } catch (e) {}
    }
    var titleEl = document.querySelector(".product-meta__title, .product__title, h1");
    return titleEl ? titleEl.textContent.trim() : "";
  }

  // ============================================================
  // MODULE: Linked Variants Cache
  // ============================================================

  function getLinkedMontageVariantId(mainVariantId) {
    try {
      var rel = JSON.parse(localStorage.getItem("montageRelationships") || "{}");
      return rel[String(mainVariantId)] || null;
    } catch (e) { return null; }
  }

  function getLinkedShippingVariantId(mainVariantId) {
    try {
      var rel = JSON.parse(localStorage.getItem("shippingRelationships") || "{}");
      return rel[String(mainVariantId)] || null;
    } catch (e) { return null; }
  }

  window.getLinkedMontageVariantId = getLinkedMontageVariantId;
  window.getLinkedShippingVariantId = getLinkedShippingVariantId;

  function setLinkedRelationship(key, mainVariantId, linkedVariantId) {
    try {
      var rel = JSON.parse(localStorage.getItem(key) || "{}");
      rel[String(mainVariantId)] = String(linkedVariantId);
      localStorage.setItem(key, JSON.stringify(rel));
    } catch (e) {}
  }

  function bootstrapRelationshipsFromDOM() {
    // From product page linked-variants JSON
    var linkedEl = document.querySelector('[id^="linked-variants-data-"]');
    if (linkedEl) {
      try {
        var data = JSON.parse(linkedEl.textContent.trim());
        for (var vid in data) {
          if (data[vid] && data[vid].length > 0 && data[vid][0].id) {
            setLinkedRelationship("montageRelationships", vid, data[vid][0].id);
          }
        }
      } catch (e) {}
    }

    // From window.variantShippingProductIds
    if (window.variantShippingProductIds) {
      for (var svid in window.variantShippingProductIds) {
        var shippingId = window.variantShippingProductIds[svid];
        if (shippingId) setLinkedRelationship("shippingRelationships", svid, shippingId);
      }
    }

    // From mini-cart/cart DOM data attributes
    var items = document.querySelectorAll(
      ".mini-cart__line-item[data-main-variant-id], tr[data-main-variant-id]"
    );
    items.forEach(function (el) {
      var mainId = el.getAttribute("data-main-variant-id");
      if (!mainId) return;
      var linkedIds = el.getAttribute("data-linked-variant-ids");
      if (linkedIds && !getLinkedMontageVariantId(mainId)) {
        setLinkedRelationship("montageRelationships", mainId, linkedIds.split(",")[0]);
      }
      var shippingId = el.getAttribute("data-linked-shipping-id");
      if (shippingId && !getLinkedShippingVariantId(mainId)) {
        setLinkedRelationship("shippingRelationships", mainId, shippingId);
      }
    });
  }

  // ============================================================
  // MODULE: Cart Sync Utilities
  // ============================================================

  // Cart cache — shared across a sync chain to avoid redundant /cart.js fetches.
  // /cart/change.js, /cart/update.js, /cart/clear.js responses populate the cache
  // directly (they return the full cart). /cart/add.js invalidates the cache.
  // A 2-second TTL guards against staleness from theme-internal cart mutations.
  var cartCache = null;
  var cartCacheTime = 0;
  var cartCachePromise = null;
  var CART_CACHE_TTL_MS = 2000;

  function getCart() {
    if (cartCache && (Date.now() - cartCacheTime) < CART_CACHE_TTL_MS) {
      return Promise.resolve(cartCache);
    }
    if (cartCachePromise) return cartCachePromise;
    cartCachePromise = fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        cartCache = cart;
        cartCacheTime = Date.now();
        cartCachePromise = null;
        return cart;
      })
      .catch(function (err) {
        cartCachePromise = null;
        throw err;
      });
    return cartCachePromise;
  }

  function invalidateCartCache() {
    cartCache = null;
    cartCacheTime = 0;
    cartCachePromise = null;
  }

  // Wraps a callback-style sync(cb) function as a Promise, so we can Promise.all them.
  function promisify(syncFn) {
    return new Promise(function (resolve) {
      try { syncFn(resolve); } catch (e) { resolve(); }
    });
  }

  window.spaInvalidateCartCache = invalidateCartCache;

  function fetchWithRetry(url, options, retries) {
    retries = retries || 3;
    // /cart/change.js, /cart/update.js, /cart/clear.js return the full updated cart —
    // use their response to populate the cache instead of re-fetching.
    // /cart/add.js returns only the added item(s), so we must invalidate.
    var returnsFullCart = /\/cart\/(change|update|clear)\.js/.test(url);
    var isAdd = /\/cart\/add\.js/.test(url);
    return fetch(url, options).then(function (res) {
      if (res.status === 429 && retries > 0) {
        var delay = (4 - retries) * 1000;
        return new Promise(function (resolve) {
          setTimeout(resolve, delay);
        }).then(function () { return fetchWithRetry(url, options, retries - 1); });
      }
      if (isAdd) {
        invalidateCartCache();
        return res;
      }
      if (returnsFullCart && res.ok) {
        return res.clone().json().then(function (cart) {
          if (cart && Array.isArray(cart.items)) {
            cartCache = cart;
            cartCacheTime = Date.now();
            cartCachePromise = null;
          } else {
            invalidateCartCache();
          }
          return res;
        }).catch(function () {
          invalidateCartCache();
          return res;
        });
      }
      return res;
    });
  }

  // Serial: for operations that must run one-after-another (e.g. quantity changes
  // on the same cart where line indices could shift).
  function serialCartChanges(ops) {
    return ops.reduce(function (chain, op) {
      return chain.then(function () {
        return fetchWithRetry("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(op)
        });
      });
    }, Promise.resolve());
  }

  // Parallel: for property-only updates on distinct line items (safe because
  // each op addresses a unique item.key and quantity stays the same).
  function parallelPropertyChanges(ops) {
    if (!ops.length) return Promise.resolve();
    return Promise.all(ops.map(function (op) {
      return fetchWithRetry("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(op)
      });
    }));
  }

  function classifyCartItem(item) {
    var handle = (item.handle || "").toLowerCase();
    var title = (item.title || "").toLowerCase();
    var vid = String(item.variant_id);

    if (handle === "montage" || handle === "montage-zubehor" || title.indexOf("montage") === 0) return "montage";
    if (handle.indexOf("versandkosten") !== -1 || title.indexOf("versandkosten") !== -1) return "shipping";
    if (vid === BAUGESUCH_VARIANT_ID || vid === KRAN_VARIANT_ID) return "service";
    return "main";
  }

  // ============================================================
  // MODULE: Duplicate Variant Consolidation
  // ============================================================

  function consolidateDuplicateVariants(callback) {
    getCart()
      .then(function (cart) {
        var seen = {};
        var updates = {};
        var hasDuplicates = false;

        cart.items.forEach(function (item) {
          if (classifyCartItem(item) !== "main") return;
          var vid = String(item.variant_id);
          if (seen[vid]) {
            updates[seen[vid].key] = seen[vid].quantity + item.quantity;
            updates[item.key] = 0;
            seen[vid].quantity += item.quantity;
            hasDuplicates = true;
          } else {
            seen[vid] = { key: item.key, quantity: item.quantity };
          }
        });

        if (hasDuplicates) {
          return fetchWithRetry("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ updates: updates })
          });
        }
      })
      .then(function () { if (callback) callback(); })
      .catch(function () { if (callback) callback(); });
  }

  // ============================================================
  // MODULE: Montage Property Sync
  // ============================================================

  function syncMontageProperty(callback) {
    var pref = getAssemblyPreference();

    getCart()
      .then(function (cart) {
        var ops = [];

        cart.items.forEach(function (item) {
          if (classifyCartItem(item) !== "main") return;
          var hasMontageProperty = item.properties && item.properties["Montage"] && item.properties["Montage"] !== "";
          var montageVariantId = getLinkedMontageVariantId(item.variant_id);

          if (pref === 2 && !hasMontageProperty && montageVariantId) {
            var newProps = Object.assign({}, item.properties || {});
            newProps["Montage"] = "Montage durch Spa Solutions";
            ops.push({ id: item.key, quantity: item.quantity, properties: newProps });
          } else if (pref === 1 && hasMontageProperty) {
            var newProps2 = Object.assign({}, item.properties || {});
            delete newProps2["Montage"];
            ops.push({ id: item.key, quantity: item.quantity, properties: newProps2 });
          }
        });

        if (ops.length > 0) {
          return parallelPropertyChanges(ops);
        }
      })
      .then(function () { if (callback) callback(); })
      .catch(function () { if (callback) callback(); });
  }

  // ============================================================
  // MODULE: Montage Sync (callback-based, self-fetching)
  // ============================================================

  function syncMontageInCart(callback, targetVariantIds) {
    console.log("[SPA-SYNC] syncMontageInCart called, pref:", getAssemblyPreference());
    var pref = String(getAssemblyPreference());
    var propertyKey = getMontagePropertyKey();
    var scoped = targetVariantIds && targetVariantIds.length > 0;

    getCart()
      .then(function (cart) {
        var montageItems = [];
        var mainProducts = [];

        cart.items.forEach(function (item) {
          var type = classifyCartItem(item);
          if (type === "montage") montageItems.push(item);
          else if (type === "main") mainProducts.push(item);
        });

        if (scoped) {
          mainProducts = mainProducts.filter(function (item) {
            return targetVariantIds.indexOf(String(item.variant_id)) !== -1;
          });
        }

        if (pref === "2") {
          // Button 2: Add Montage for each main product
          var existingFor = {};
          montageItems.forEach(function (item) {
            if (item.properties && item.properties[propertyKey]) {
              var fv = item.properties[propertyKey];
              if (!existingFor[fv]) {
                existingFor[fv] = { item: item, quantity: item.quantity, variantId: item.variant_id };
              } else {
                existingFor[fv].quantity += item.quantity;
              }
            }
          });

          var toAdd = [];
          var toAdjust = [];

          mainProducts.forEach(function (mainItem) {
            var linkedId = getLinkedMontageVariantId(mainItem.variant_id);
            if (!linkedId) return;

            var fv = buildForValue(mainItem);
            var needed = mainItem.quantity;
            var existing = existingFor[fv];

            if (existing) {
              if (existing.quantity < needed) {
                toAdd.push({ forValue: fv, montageVariantId: linkedId, quantity: needed - existing.quantity });
              } else if (existing.quantity > needed) {
                toAdjust.push({ key: existing.item.key, newQuantity: needed });
              }
              existing.handled = true;
            } else {
              toAdd.push({ forValue: fv, montageVariantId: linkedId, quantity: needed });
            }
          });

          // Remove orphaned montage (only when NOT scoped)
          var cleanupOps = [];
          if (!scoped) {
            Object.keys(existingFor).forEach(function (k) {
              if (!existingFor[k].handled) cleanupOps.push({ id: existingFor[k].item.key, quantity: 0 });
            });
            montageItems.forEach(function (item) {
              if (!item.properties || !item.properties[propertyKey]) cleanupOps.push({ id: item.key, quantity: 0 });
            });
          }
          toAdjust.forEach(function (adj) {
            cleanupOps.push({ id: adj.key, quantity: adj.newQuantity });
          });

          // Cleanup uses item.key (stable unique id) and add creates new lines,
          // so they can run in parallel — saves ~50-100ms.
          var cleanupPromise = cleanupOps.length > 0
            ? batchRemoveAndAdjust(cleanupOps)
            : Promise.resolve();
          var addPromise = Promise.resolve();
          if (toAdd.length > 0) {
            var items = toAdd.map(function (m) {
              var props = {};
              props[propertyKey] = m.forValue;
              return { id: parseInt(m.montageVariantId, 10), quantity: m.quantity, properties: props };
            });
            addPromise = fetchWithRetry("/cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ items: items })
            });
          }
          Promise.all([cleanupPromise, addPromise])
            .then(function () { if (callback) callback(); })
            .catch(function () { if (callback) callback(); });
        } else {
          // Button 1: Remove all Montage items
          var toRemove = montageItems;
          if (scoped) {
            var scopedFor = {};
            mainProducts.forEach(function (m) { scopedFor[buildForValue(m)] = true; });
            toRemove = montageItems.filter(function (item) {
              return item.properties && item.properties[propertyKey] && scopedFor[item.properties[propertyKey]];
            });
          }
          if (toRemove.length > 0) {
            var updates = {};
            toRemove.forEach(function (item) { updates[item.key] = 0; });
            fetchWithRetry("/cart/update.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ updates: updates })
            })
            .then(function () { if (callback) callback(); })
            .catch(function () { if (callback) callback(); });
          } else {
            if (callback) callback();
          }
        }
      })
      .catch(function () { if (callback) callback(); });
  }

  window.syncMontageInCart = syncMontageInCart;

  // ============================================================
  // MODULE: Shipping Sync (callback-based, self-fetching)
  // ============================================================

  // Versandkosten gelten unabhängig von der Montage-Wahl: «Montage durch
  // Spa Solutions» kommt ZUSÄTZLICH zum Versand, nicht anstelle davon
  // (ClickUp 86cajhpbt).
  function syncShippingInCart(callback, targetVariantIds) {
    console.log("[SPA-SYNC] syncShippingInCart called, pref:", getAssemblyPreference());
    var propertyKey = getMontagePropertyKey();
    var scoped = targetVariantIds && targetVariantIds.length > 0;

    getCart()
      .then(function (cart) {
        var shippingItems = [];
        var mainProducts = [];

        cart.items.forEach(function (item) {
          var type = classifyCartItem(item);
          if (type === "shipping") shippingItems.push(item);
          else if (type === "main") mainProducts.push(item);
        });

        if (scoped) {
          mainProducts = mainProducts.filter(function (item) {
            return targetVariantIds.indexOf(String(item.variant_id)) !== -1;
          });
        }

        // Add Versandkosten for each main product (any assembly preference)
        var existingFor = {};
        shippingItems.forEach(function (item) {
          if (item.properties && item.properties[propertyKey]) {
            var fv = item.properties[propertyKey];
            if (!existingFor[fv]) {
              existingFor[fv] = { item: item, quantity: item.quantity };
            } else {
              existingFor[fv].quantity += item.quantity;
            }
          }
        });

        var toAdd = [];
        var toAdjust = [];

        mainProducts.forEach(function (mainItem) {
          var fv = buildForValue(mainItem);
          var needed = mainItem.quantity;
          var existing = existingFor[fv];

          if (existing) {
            if (existing.quantity < needed) {
              toAdd.push({ forValue: fv, quantity: needed - existing.quantity, mainVariantId: mainItem.variant_id });
            } else if (existing.quantity > needed) {
              toAdjust.push({ key: existing.item.key, newQuantity: needed });
            }
            existing.handled = true;
          } else {
            toAdd.push({ forValue: fv, quantity: needed, mainVariantId: mainItem.variant_id });
          }
        });

        // Remove orphaned shipping (only when NOT scoped)
        var cleanupOps = [];
        if (!scoped) {
          Object.keys(existingFor).forEach(function (k) {
            if (!existingFor[k].handled) cleanupOps.push({ id: existingFor[k].item.key, quantity: 0 });
          });
          shippingItems.forEach(function (item) {
            if (!item.properties || !item.properties[propertyKey]) cleanupOps.push({ id: item.key, quantity: 0 });
          });
        }
        toAdjust.forEach(function (adj) {
          cleanupOps.push({ id: adj.key, quantity: adj.newQuantity });
        });

        var cleanupPromise2 = cleanupOps.length > 0
          ? batchRemoveAndAdjust(cleanupOps)
          : Promise.resolve();
        var addPromise2 = Promise.resolve();
        if (toAdd.length > 0) {
          var itemsPayload = toAdd
            .map(function (s) {
              var shippingVariantId = getLinkedShippingVariantId(s.mainVariantId);
              if (!shippingVariantId) return null;
              var props = {};
              props[propertyKey] = s.forValue;
              return { id: parseInt(shippingVariantId, 10), quantity: s.quantity, properties: props };
            })
            .filter(Boolean);

          if (itemsPayload.length > 0) {
            addPromise2 = fetchWithRetry("/cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ items: itemsPayload })
            });
          }
        }
        Promise.all([cleanupPromise2, addPromise2])
          .then(function () { if (callback) callback(); })
          .catch(function () { if (callback) callback(); });
      })
      .catch(function () { if (callback) callback(); });
  }

  window.syncShippingInCart = syncShippingInCart;

  // Helper: batch remove + sequential adjust
  function batchRemoveAndAdjust(ops) {
    var removeOps = {};
    var adjustOps = [];
    ops.forEach(function (op) {
      if (op.quantity === 0) {
        removeOps[op.id] = 0;
      } else {
        adjustOps.push(op);
      }
    });

    var chain = Promise.resolve();
    if (Object.keys(removeOps).length > 0) {
      chain = chain.then(function () {
        return fetchWithRetry("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ updates: removeOps })
        });
      });
    }
    if (adjustOps.length > 0) {
      chain = chain.then(function () {
        return serialCartChanges(adjustOps);
      });
    }
    return chain;
  }

  // ============================================================
  // MODULE: Service Items Sync (Baugesuch + Kran)
  // ============================================================

  // Source of truth: the main product's own line-item property (e.g. "Kranservice",
  // "Baugesuch"). A global localStorage flag previously drove this, which leaked
  // across products — adding a Pergola to cart could pull in Kran just because an
  // earlier whirlpool interaction had set cartKranSelected=true.
  function syncServiceItemInCart(callback, propertyName, proValuePrefix, variantId) {
    var propertyKey = getMontagePropertyKey();

    getCart()
      .then(function (cart) {
        var serviceItems = [];
        var mainProductTitles = [];

        cart.items.forEach(function (item) {
          if (String(item.variant_id) === String(variantId)) {
            serviceItems.push(item);
            return;
          }
          if (classifyCartItem(item) !== "main") return;

          // Only count campaign products (those with a montage relationship)
          // Accessories (filters, cover lifts) don't need Baugesuch/Kran
          var hasMontageRel = getLinkedMontageVariantId(item.variant_id);
          var hasShippingRel = getLinkedShippingVariantId(item.variant_id);
          if (!hasMontageRel && !hasShippingRel) return;

          var propValue = (item.properties && item.properties[propertyName]) || "";
          if (propValue.indexOf(proValuePrefix) !== 0) return;

          var title = item.product_title || "";
          if (item.variant_title && item.variant_title !== "Default Title") {
            title += " " + item.variant_title;
          }
          if (title && mainProductTitles.indexOf(title) === -1) {
            mainProductTitles.push(title);
          }
        });

        var wantItem = mainProductTitles.length > 0;
        var forValue = mainProductTitles.join(", ");

        if (wantItem) {
          if (serviceItems.length === 0) {
            // Add exactly 1
            var props = {};
            if (forValue) props[propertyKey] = forValue;
            return fetchWithRetry("/cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1, properties: props }] })
            });
          }

          // Already exists — ensure exactly 1 with updated Für
          var keepItem = serviceItems[0];
          var currentFor = (keepItem.properties && keepItem.properties[propertyKey]) || "";

          // Remove duplicates
          if (serviceItems.length > 1) {
            var dupeUpdates = {};
            for (var i = 1; i < serviceItems.length; i++) {
              dupeUpdates[serviceItems[i].key] = 0;
            }
            fetchWithRetry("/cart/update.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ updates: dupeUpdates })
            });
          }

          // Update Für property or fix quantity
          if (keepItem.quantity !== 1 || currentFor !== forValue) {
            var changeProps = {};
            changeProps[propertyKey] = forValue;
            return fetchWithRetry("/cart/change.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ id: keepItem.key, quantity: 1, properties: changeProps })
            });
          }
        } else {
          // Remove all service items of this type
          if (serviceItems.length > 0) {
            var updates = {};
            serviceItems.forEach(function (item) { updates[item.key] = 0; });
            return fetchWithRetry("/cart/update.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ updates: updates })
            });
          }
        }
      })
      .then(function () { if (callback) callback(); })
      .catch(function (err) {
        console.error("[SPA-SYNC] syncServiceItem error:", err);
        if (callback) callback();
      });
  }

  function syncBaugesuchInCart(callback) {
    syncServiceItemInCart(callback, "Baugesuch", "Baugesuch über", BAUGESUCH_VARIANT_ID);
  }

  function syncKranInCart(callback) {
    syncServiceItemInCart(callback, "Kranservice", "Kran über", KRAN_VARIANT_ID);
  }

  window.syncBaugesuchInCart = syncBaugesuchInCart;
  window.syncKranInCart = syncKranInCart;

  // ============================================================
  // MODULE: Checkout Redirect (with final sync)
  // ============================================================

  function getActiveDiscountCode() {
    var pref = getAssemblyPreference();
    var btn = pref === 2
      ? document.getElementById("discount-button-2")
      : document.getElementById("discount-button-1");

    if (btn) {
      return btn.getAttribute("data-discount-code") || "";
    }

    // Fallback: read from cart items
    var items = document.querySelectorAll(".mini-cart__line-item, tr[id^='CartItem-']");
    var code = "";
    items.forEach(function (item) {
      if (code) return;
      code = pref === 1
        ? (item.getAttribute("data-campaign-code-eigenmontage") || "")
        : (item.getAttribute("data-campaign-code-montage") || "");
    });
    return code;
  }

  function setupCheckoutRedirects() {
    if (document.documentElement.dataset.spaChkBound) return;
    document.documentElement.dataset.spaChkBound = "true";

    document.addEventListener("click", function (e) {
      var checkoutBtn = e.target.closest('button[name="checkout"], a[href*="/checkout"]');
      if (!checkoutBtn) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      checkoutBtn.disabled = true;

      // Final sync before checkout
      consolidateDuplicateVariants(function () {
        syncMontageProperty(function () {
          Promise.all([
            promisify(syncMontageInCart),
            promisify(syncShippingInCart),
            promisify(syncBaugesuchInCart),
            promisify(syncKranInCart)
          ]).then(function () {
            var code = getActiveDiscountCode();
            var url = code ? "/checkout?discount=" + encodeURIComponent(code) : "/checkout";
            window.location.href = url;
          });
        });
      });

      return false;
    }, true);

    document.addEventListener("submit", function (e) {
      var form = e.target;
      if (!form || form.tagName !== "FORM") return;
      var submitter = e.submitter;
      var isCheckoutSubmit =
        form.getAttribute("action") === "/checkout" ||
        (submitter && submitter.name === "checkout");
      if (!isCheckoutSubmit) return;

      e.preventDefault();
      e.stopPropagation();

      consolidateDuplicateVariants(function () {
        syncMontageProperty(function () {
          Promise.all([
            promisify(syncMontageInCart),
            promisify(syncShippingInCart),
            promisify(syncBaugesuchInCart),
            promisify(syncKranInCart)
          ]).then(function () {
            var code = getActiveDiscountCode();
            var url = code ? "/checkout?discount=" + encodeURIComponent(code) : "/checkout";
            window.location.href = url;
          });
        });
      });

      return false;
    }, true);
  }

  // ============================================================
  // MODULE: Cart Drawer (Mini-Cart) Discount Application
  // ============================================================

  function applyMiniCartDiscounts() {
    var pref = getAssemblyPreference();
    var items = document.querySelectorAll(".mini-cart__line-item");
    var totals = { original: 0, discounted: 0, hasDiscount: false };

    items.forEach(function (item) {
      var handle = (item.getAttribute("data-product-handle") || "").toLowerCase();
      var isMontage = handle === "montage" || handle === "montage-zubehor";
      var isShipping = handle.indexOf("versandkosten") !== -1;

      if (isMontage || isShipping) {
        var linePrice = parseInt(item.getAttribute("data-original-price") || "0", 10);
        var qty = parseInt(item.getAttribute("data-quantity") || "1", 10);
        totals.original += linePrice * qty;
        totals.discounted += linePrice * qty;
        var pill = item.querySelector(".custom-discount-pill");
        if (pill) pill.remove();
        return;
      }

      var hasCampaign = item.hasAttribute("data-campaign-eigenmontage-pct") || item.hasAttribute("data-campaign-montage-pct");
      if (!hasCampaign) {
        var linePrice2 = parseInt(item.getAttribute("data-original-price") || "0", 10);
        var qty2 = parseInt(item.getAttribute("data-quantity") || "1", 10);
        var finalLinePrice2 = parseInt(item.getAttribute("data-final-line-price") || "0", 10);
        totals.original += linePrice2 * qty2;
        totals.discounted += finalLinePrice2 > 0 ? finalLinePrice2 : linePrice2 * qty2;
        if (finalLinePrice2 > 0 && finalLinePrice2 < linePrice2 * qty2) {
          totals.hasDiscount = true;
        }
        return;
      }

      var pctAttr = pref === 1 ? "data-campaign-eigenmontage-pct" : "data-campaign-montage-pct";
      var codeAttr = pref === 1 ? "data-campaign-code-eigenmontage" : "data-campaign-code-montage";
      var pct = parseFloat(item.getAttribute(pctAttr) || "0");
      var code = item.getAttribute(codeAttr) || "";
      var originalPrice = parseInt(item.getAttribute("data-original-price") || "0", 10);
      var quantity = parseInt(item.getAttribute("data-quantity") || "1", 10);

      var priceList = item.querySelector(".mini-cart__price-list");
      var priceEl = priceList ? (priceList.querySelector(".amount") || priceList.querySelector(".price")) : null;

      if (pct > 0 && originalPrice > 0) {
        var discountAmount = Math.round(originalPrice * (pct / 100));
        var finalPrice = originalPrice - discountAmount;

        if (priceEl) {
          var qtyPrefix = quantity > 1 ? '<span class="mini-quantity">' + quantity + '&times;</span> ' : '';
          priceEl.innerHTML = qtyPrefix +
            '<s style="color:#db4141;display:block;">' + formatMoney(originalPrice) + '</s> ' +
            '<span class="price--highlight">' + formatMoney(finalPrice) + '</span>';
        }

        totals.original += originalPrice * quantity;
        totals.discounted += finalPrice * quantity;
        totals.hasDiscount = true;

        // Discount pill
        if (!item.querySelector(".custom-discount-pill") && code) {
          var pill = document.createElement("div");
          pill.className = "custom-discount-pill selected-applied-discount";
          pill.innerHTML =
            '<span><svg width="12" height="12" aria-hidden="true" focusable="false" viewBox="0 0 12 12">' +
            '<path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor"></path></svg></span>' +
            '<span>' + code + ' (-' + pct + '%)</span>';
          var productInfo = item.querySelector(".mini-cart__product-info");
          if (productInfo) productInfo.appendChild(pill);
        }
      } else {
        // No discount for this button
        if (priceEl) priceEl.textContent = formatMoney(originalPrice);
        var existingPill = item.querySelector(".custom-discount-pill");
        if (existingPill) existingPill.remove();

        totals.original += originalPrice * quantity;
        totals.discounted += originalPrice * quantity;
      }
    });

    // Update subtotal
    var subtotalEls = document.querySelectorAll(".mini-cart__recap-price-line span:last-child");
    subtotalEls.forEach(function (el) {
      if (totals.hasDiscount) {
        el.innerHTML = '<s style="color:#db4141;">' + formatMoney(totals.original) + '</s> ' + formatMoney(totals.discounted);
      }
    });
  }

  window.applyCartDrawerDiscounts = applyMiniCartDiscounts;

  // ============================================================
  // MODULE: Cart Page Discount Application
  // ============================================================

  function applyCartPageDiscounts() {
    if (!/\/cart(\?|$|\/?$)/.test(window.location.pathname)) return;

    var pref = getAssemblyPreference();
    var rows = document.querySelectorAll('tr[id^="CartItem-"]');
    var totals = { original: 0, discounted: 0, hasDiscount: false };

    rows.forEach(function (row) {
      var handle = (row.getAttribute("data-product-handle") || "").toLowerCase();
      var isMontage = handle === "montage" || handle === "montage-zubehor";

      var hasCampaign = row.hasAttribute("data-campaign-eigenmontage-pct") || row.hasAttribute("data-campaign-montage-pct");
      if (isMontage || !hasCampaign) {
        var origPrice = parseInt(row.getAttribute("data-original-price") || "0", 10);
        var itemQty = parseInt(row.getAttribute("data-quantity") || "1", 10);
        var finalLP = parseInt(row.getAttribute("data-final-line-price") || "0", 10);
        var origLineTotal = origPrice * itemQty;
        var discLineTotal = finalLP > 0 ? finalLP : origLineTotal;
        totals.original += origLineTotal;
        totals.discounted += discLineTotal;
        if (discLineTotal < origLineTotal) {
          totals.hasDiscount = true;
        }
        return;
      }

      var pctAttr = pref === 1 ? "data-campaign-eigenmontage-pct" : "data-campaign-montage-pct";
      var codeAttr = pref === 1 ? "data-campaign-code-eigenmontage" : "data-campaign-code-montage";
      var pct = parseFloat(row.getAttribute(pctAttr) || "0");
      var code = row.getAttribute(codeAttr) || "";

      var priceCell = row.querySelector(".line-item__price-list .line-item__price")
        || row.querySelector(".line-item__price");
      if (!priceCell) return;

      var originalPrice = parseMoneyTextToCents(priceCell.textContent);
      var qtyInput = row.querySelector('.line-item__quantity-wrapper input[type="number"]');
      var quantity = qtyInput ? parseInt(qtyInput.value || "1") : 1;

      if (pct > 0 && originalPrice > 0) {
        var discountAmount = Math.round(originalPrice * (pct / 100));
        var finalPrice = originalPrice - discountAmount;

        priceCell.innerHTML =
          '<s style="color:#db4141;display:block;">' + formatMoney(originalPrice) + '</s> ' +
          '<span class="price--highlight">' + formatMoney(finalPrice) + '</span>';

        var lineTotal = row.querySelector(".line-item__line-price");
        if (lineTotal && lineTotal !== priceCell) {
          lineTotal.innerHTML =
            '<s style="color:#db4141;display:block;">' + formatMoney(originalPrice * quantity) + '</s> ' +
            '<span class="price--highlight">' + formatMoney(finalPrice * quantity) + '</span>';
        }

        totals.original += originalPrice * quantity;
        totals.discounted += finalPrice * quantity;
        totals.hasDiscount = true;

        // Discount pill
        if (!row.querySelector(".custom-discount-pill") && code) {
          var pill = document.createElement("div");
          pill.className = "custom-discount-pill selected-applied-discount";
          pill.innerHTML =
            '<span><svg width="12" height="12" aria-hidden="true" focusable="false" viewBox="0 0 12 12">' +
            '<path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor"></path></svg></span>' +
            '<span>' + code + ' (-' + pct + '%)</span>';
          var meta = row.querySelector(".line-item__meta") || row.querySelector(".line-item__product-info");
          if (meta) meta.appendChild(pill);
        }
      } else {
        totals.original += originalPrice * quantity;
        totals.discounted += originalPrice * quantity;
      }
    });

    // Update subtotal
    if (totals.hasDiscount) {
      var subtotalEls = document.querySelectorAll(".cart-recap__price-line-price");
      subtotalEls.forEach(function (el) {
        el.innerHTML = '<s style="color:#db4141;">' + formatMoney(totals.original) + '</s> ' + formatMoney(totals.discounted);
      });
    }
  }

  // ============================================================
  // MODULE: Mini-Cart Helpers
  // ============================================================

  function updateMiniCartFromSections(sections) {
    var html = sections["mini-cart"];
    if (!html) return;
    var miniCartContainer = document.getElementById("mini-cart");
    if (!miniCartContainer) return;

    var parser = new DOMParser();
    var doc = parser.parseFromString(html, "text/html");
    var newContent = doc.getElementById("mini-cart");
    if (newContent) miniCartContainer.innerHTML = newContent.innerHTML;

    requestAnimationFrame(function () {
      applyMiniCartDiscounts();
      initCartAssemblyToggles();
    });
  }

  function openMiniCart() {
    var drawer = document.querySelector(".mini-cart__drawer, [data-mini-cart]");
    if (drawer) {
      drawer.classList.add("is-open");
      document.body.classList.add("mini-cart-open");
      document.dispatchEvent(new CustomEvent("cart-drawer:open"));
    }
  }

  function closeMiniCart() {
    var drawer = document.querySelector(".mini-cart__drawer, [data-mini-cart]");
    if (drawer) {
      drawer.classList.remove("is-open");
      document.body.classList.remove("mini-cart-open");
    }
  }

  function updateBubbleCount(count) {
    document.querySelectorAll(".header__cart-count, [data-cart-count], .js-cart-count").forEach(function (el) {
      el.textContent = count;
      if (count > 0) el.classList.remove("hidden");
    });
  }

  window.updateMiniCartFromSections = updateMiniCartFromSections;
  window.openMiniCart = openMiniCart;
  window.closeMiniCart = closeMiniCart;
  window.updateBubbleCount = updateBubbleCount;

  // ============================================================
  // MODULE: Info Modal
  // ============================================================

  function openDiscountInfoModalFromTemplate(triggerElement) {
    if (!triggerElement) return;
    var popupId = triggerElement.getAttribute("data-popup-id");
    if (!popupId) return;

    var template = document.querySelector('[data-popup-template="' + popupId + '"]');
    var modal = document.querySelector(".discount-info-modal");
    if (!template || !modal) return;

    var modalBody = modal.querySelector(".discount-info-modal-content-inner");
    if (modalBody) {
      modalBody.innerHTML = template.innerHTML;
      modalBody.scrollTop = 0;
    }

    if (triggerElement.classList.contains("architect-info")) {
      var content = modal.querySelector(".discount-info-modal-content");
      if (content) content.classList.add("is-architect-popup");
    }

    modal.classList.add("active");
    document.body.style.overflow = "hidden";
  }

  window.openDiscountInfoModalFromTemplate = openDiscountInfoModalFromTemplate;

  // Modal close
  document.addEventListener("click", function (e) {
    if (e.target.closest(".discount-info-modal-close")) {
      var modal = document.querySelector(".discount-info-modal");
      if (modal) { modal.classList.remove("active"); document.body.style.overflow = ""; }
      return;
    }
    if (e.target.classList && e.target.classList.contains("discount-info-modal") && e.target.classList.contains("active")) {
      e.target.classList.remove("active");
      document.body.style.overflow = "";
    }
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      var modal = document.querySelector(".discount-info-modal.active");
      if (modal) { modal.classList.remove("active"); document.body.style.overflow = ""; }
    }
  });

  // ============================================================
  // MODULE: Add-to-Cart (no fetch wrapping)
  // ============================================================

  var _addToCartPending = false;

  function initAddToCartSync() {
    // Mark that an add-to-cart is pending when user clicks AddToCart
    document.addEventListener("click", function (e) {
      var addBtn = e.target.closest("#AddToCart, [name='add']");
      if (!addBtn) return;
      bootstrapRelationshipsFromDOM();
      _addToCartPending = true;
    }, true);

    // Listen for cart events that the theme fires AFTER add-to-cart completes
    // These events fire when the mini-cart is updated with the new item
    ["cart-drawer:open", "cart-drawer:refresh", "cart:refresh"].forEach(function (eventName) {
      document.addEventListener(eventName, function () {
        if (!_addToCartPending) return;
        _addToCartPending = false;
        // Small delay to ensure theme has finished rendering
        setTimeout(runPostAddSync, 300);
      });
    });

    // Fallback: if theme doesn't fire events, use a timed fallback after click
    document.addEventListener("click", function (e) {
      var addBtn = e.target.closest("#AddToCart, [name='add']");
      if (!addBtn) return;
      setTimeout(function () {
        if (_addToCartPending) {
          _addToCartPending = false;
          runPostAddSync();
        }
      }, 3000);
    }, true);
  }

  function runPostAddSync() {
    setCartSyncingState();
    console.log("[SPA-SYNC] runPostAddSync starting, pref:", getAssemblyPreference());
    console.log("[SPA-SYNC] montageRels:", localStorage.getItem("montageRelationships"));
    console.log("[SPA-SYNC] shippingRels:", localStorage.getItem("shippingRelationships"));
    // After add-to-cart: consolidate + property sync must run first (they mutate
    // main-product state). Then the 4 companion syncs run in parallel (disjoint
    // line items: montage / shipping / baugesuch / kran).
    consolidateDuplicateVariants(function () {
      syncMontageProperty(function () {
        Promise.all([
          promisify(syncMontageInCart),
          promisify(syncShippingInCart),
          promisify(syncBaugesuchInCart),
          promisify(syncKranInCart)
        ]).then(function () {
          refreshMiniCartSection();
        });
      });
    });
  }

  // Refresh /cart page via Section Rendering API instead of full-page reload.
  // Preserves scroll position and avoids re-fetching all theme assets (~1-2s saved).
  function refreshCartPageSection() {
    return fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/") + "?sections=main-cart", { headers: { "Accept": "application/json" } })
      .then(function (res) { return res.json(); })
      .then(function (sections) {
        var html = sections["main-cart"];
        if (!html) return;
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, "text/html");
        // The section's outer shopify-section wrapper is what we need to replace.
        var newSection = doc.querySelector('[id^="shopify-section-"]') || doc.body.firstElementChild;
        var currentSection = document.querySelector('[id^="shopify-section-main-cart"]')
          || document.querySelector('[data-section-type="cart"]')
          || document.querySelector('.main-cart, main .cart');
        if (newSection && currentSection) {
          currentSection.innerHTML = newSection.innerHTML;
        }
        requestAnimationFrame(function () {
          if (typeof window.applyCartPageDiscounts === "function") window.applyCartPageDiscounts();
          if (typeof window.initCartAssemblyToggles === "function") window.initCartAssemblyToggles();
          clearCartSyncingState();
        });
      })
      .catch(function (err) {
        console.error("[SPA-SYNC] refreshCartPageSection error, falling back to reload:", err);
        window.location.reload();
      });
  }

  function refreshMiniCartSection() {
    fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/") + "?sections=mini-cart", { headers: { "Accept": "application/json" } })
      .then(function (res) { return res.json(); })
      .then(function (sections) {
        var html = sections["mini-cart"];
        if (!html) return;
        var miniCart = document.getElementById("mini-cart");
        if (!miniCart) return;

        var parser = new DOMParser();
        var doc = parser.parseFromString(html, "text/html");
        var newContent = doc.getElementById("mini-cart");
        if (newContent) {
          miniCart.innerHTML = newContent.innerHTML;
        }

        // Read item count from the freshly rendered HTML (data-item-count on
        // #mini-cart root) instead of a second /cart.js round-trip.
        var countAttr = newContent ? newContent.getAttribute("data-item-count") : null;
        if (countAttr !== null) {
          updateBubbleCount(parseInt(countAttr, 10) || 0);
          miniCart.setAttribute("data-item-count", countAttr);
        }

        // Apply discounts + toggles to the fresh HTML, then clear loading state
        requestAnimationFrame(function () {
          applyMiniCartDiscounts();
          initCartAssemblyToggles();
          clearCartSyncingState();
        });
      })
      .catch(function (err) {
        console.error("[SPA-SYNC] refreshMiniCartSection error:", err);
      });
  }

  // ============================================================
  // MODULE: Cart Quantity Change Sync
  // ============================================================

  function initCartQuantityChangeSync() {
    var isCartPage = /\/cart(\?|$|\/?$)/.test(window.location.pathname);

    function runQuantitySync() {
      setCartSyncingState();
      var safetyTimer = setTimeout(function () {
        console.warn("[SPA-SYNC] Quantity sync safety timeout — clearing syncing state");
        clearCartSyncingState();
      }, 12000);

      setTimeout(function () {
        Promise.all([
          promisify(syncMontageInCart),
          promisify(syncShippingInCart),
          promisify(syncBaugesuchInCart),
          promisify(syncKranInCart)
        ]).then(function () {
          clearTimeout(safetyTimer);
          if (isCartPage) {
            refreshCartPageSection();
          } else {
            refreshMiniCartSection();
          }
        });
      }, 1500);
    }

    document.addEventListener("click", function (e) {
      var btn = e.target.closest(
        '[data-action="decrease-quantity"], [data-action="increase-quantity"]'
      );
      if (!btn) return;

      var qty = parseInt(btn.getAttribute("data-quantity") || "0", 10);
      // qty === 0 is a removal — handled by initCartItemRemoval
      if (qty === 0) return;

      // Check if this is a campaign product (has linked variant data)
      var lineItem = btn.closest(".mini-cart__line-item, .cart__item, tr[data-variant-id], .line-item");
      if (!lineItem) return;

      var linkedVariants = lineItem.getAttribute("data-linked-variant-ids") || "";
      var linkedShipping = lineItem.getAttribute("data-linked-shipping-id") || "";
      if (!linkedVariants && !linkedShipping) return;

      console.log("[SPA-SYNC] Campaign product quantity changed to", qty, "— scheduling companion sync");
      runQuantitySync();
    }, true);

    // Also handle direct input changes on quantity fields
    document.addEventListener("change", function (e) {
      var input = e.target;
      if (!input.classList || !input.classList.contains("quantity-selector__value")) return;

      var lineItem = input.closest(".mini-cart__line-item, .cart__item, tr[data-variant-id], .line-item");
      if (!lineItem) return;

      var linkedVariants = lineItem.getAttribute("data-linked-variant-ids") || "";
      var linkedShipping = lineItem.getAttribute("data-linked-shipping-id") || "";
      if (!linkedVariants && !linkedShipping) return;

      console.log("[SPA-SYNC] Campaign product quantity input changed — scheduling companion sync");
      runQuantitySync();
    }, true);
  }

  // ============================================================
  // MODULE: Cart Item Removal
  // ============================================================

  function initCartItemRemoval() {
    var isCartPage = /\/cart(\?|$|\/?$)/.test(window.location.pathname);

    document.addEventListener("click", function (e) {
      var removeLink = e.target.closest(
        'a[data-action="decrease-quantity"][data-quantity="0"], .mini-cart__quantity-remove, [data-cart-remove]'
      );
      if (!removeLink) return;

      // After theme removes item, run sync to clean up orphaned companions
      setCartSyncingState();
      var safetyTimer = setTimeout(function () {
        console.warn("[SPA-SYNC] Removal sync safety timeout — clearing syncing state");
        clearCartSyncingState();
      }, 12000);

      setTimeout(function () {
        Promise.all([
          promisify(syncMontageInCart),
          promisify(syncShippingInCart),
          promisify(syncBaugesuchInCart),
          promisify(syncKranInCart)
        ]).then(function () {
          clearTimeout(safetyTimer);
          if (isCartPage) {
            refreshCartPageSection();
          } else {
            refreshMiniCartSection();
          }
        });
      }, 1500);
    }, true);
  }

  // ============================================================
  // MODULE: Initialization
  // ============================================================

  function init() {
    bootstrapRelationshipsFromDOM();

    // Sync PDP discount buttons with stored preference
    var pref = getAssemblyPreference();
    var allDiscountButtons = document.querySelectorAll(".discount-button");
    allDiscountButtons.forEach(function (btn) {
      var btnNum = parseInt(btn.getAttribute("data-button-number") || "0", 10);
      btn.classList.toggle("active", btnNum === pref);
    });

    // Product page
    if (window.isProductPage === true) {
      setTimeout(function () {
        updateProductPagePrice();
        updateMontageProperty();
        initCartAssemblyToggles();
      }, 150);
    }

    // Cart page
    if (/\/cart(\?|$|\/?$)/.test(window.location.pathname)) {
      setTimeout(function () {
        applyCartPageDiscounts();
        initCartAssemblyToggles();
      }, 150);
    }

    // No init-time sync — sync only runs on user interaction
    // (button click, cart assembly toggle, add-to-cart, remove)
    // This avoids race conditions with stale preference data.
    initCartAssemblyToggles();

    // Mini-cart MutationObserver
    var miniCart = document.getElementById("mini-cart");
    if (miniCart) {
      var isApplying = false;
      var observer = new MutationObserver(function () {
        if (isApplying) return;
        isApplying = true;
        observer.disconnect();
        applyMiniCartDiscounts();
        initCartAssemblyToggles();
        observer.observe(miniCart, { childList: true, subtree: true });
        isApplying = false;
      });
      observer.observe(miniCart, { childList: true, subtree: true });
    }

    // Variant change listeners
    document.addEventListener("variant:change", handleVariantChange);
    document.addEventListener("variant:changed", handleVariantChange);
    document.addEventListener("product:variant-change", handleVariantChange);

    // Cart events
    document.addEventListener("cart-drawer:refresh", function () {
      requestAnimationFrame(applyMiniCartDiscounts);
    });
    document.addEventListener("cart-drawer:open", function () {
      requestAnimationFrame(applyMiniCartDiscounts);
    });
    document.addEventListener("cart:refresh", function () {
      requestAnimationFrame(applyMiniCartDiscounts);
    });

    // Add-to-cart, quantity change, and removal
    initAddToCartSync();
    initCartQuantityChangeSync();
    initCartItemRemoval();

    // Checkout
    setupCheckoutRedirects();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // ============================================================
  // MODULE: Public API & Legacy Compat
  // ============================================================

  window.SpaDiscounts = {
    handleButtonClick: window.handleDiscountButtonClick,
    updateProductPagePrice: updateProductPagePrice,
    applyMiniCartDiscounts: applyMiniCartDiscounts,
    applyCartPageDiscounts: applyCartPageDiscounts,
    formatMoney: formatMoney,
    getAssemblyPreference: getAssemblyPreference,
    getActiveDiscountCode: getActiveDiscountCode,
    syncMontageInCart: syncMontageInCart,
    syncShippingInCart: syncShippingInCart
  };

  // Legacy stubs
  window.isThisCartPage = function () { return /\/cart(\?|$|\/?$)/.test(window.location.pathname); };
  window.recalculateMiniCartHeight = function () {};
  window.getDiscountPreference = function () {
    var pref = getAssemblyPreference();
    var btn = pref === 2
      ? document.getElementById("discount-button-2")
      : document.getElementById("discount-button-1");
    return btn ? (btn.getAttribute("data-discount-code") || "") : "";
  };
  window.hasNoDiscountPreference = function () { return false; };
  window.updatePrice = function () {
    updateProductPagePrice();
  };

})();
